import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/constants";

export const MobileCallCTA = () => (
  <motion.a
    href={PHONE_TEL}
    initial={{ y: 100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 1.6, duration: 0.6 }}
    className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#D4AF37] text-black px-4 py-3.5 flex items-center justify-center gap-2.5 font-medium tracking-[0.1em] uppercase text-xs sm:text-sm btn-luxury"
    data-testid="mobile-sticky-call"
  >
    <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
    <span className="whitespace-nowrap">Call : {PHONE_DISPLAY}</span>
  </motion.a>
);